module.exports = __webpack_public_path__ + "media/images/country_flags/md-8e671f60fb8ad26c0fddee5764c2c8b4.png";